import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';
import type { TranscriptionSuccessResponse } from './types';

export class TranscriptionService {
  static async getFile(audioUrl: string, audioCuid: string) {
    try {
      const response = await fetch(audioUrl);
      const blob = await response.blob();

      // Obtém o tipo MIME real do arquivo baixado
      const mimeType = response.headers.get('content-type') || blob.type;

      // Garante que o tipo MIME seja um tipo de áudio válido
      const validAudioTypes = [
        'audio/mpeg',
        'audio/mp3',
        'audio/wav',
        'audio/ogg',
        'audio/webm',
      ];
      const fileType = validAudioTypes.includes(mimeType)
        ? mimeType
        : 'audio/mpeg';

      // Determina a extensão do arquivo baseado no tipo MIME
      const extension =
        fileType === 'audio/mpeg' || fileType === 'audio/mp3'
          ? 'mp3'
          : fileType === 'audio/wav'
          ? 'wav'
          : fileType === 'audio/ogg'
          ? 'ogg'
          : fileType === 'audio/webm'
          ? 'webm'
          : 'mp3';

      const file = new File([blob], `audio.${audioCuid}.${extension}`, {
        type: fileType,
        lastModified: new Date().getTime(),
      });

      return file;
    } catch (error) {
      throw new Error(`Erro ao processar arquivo de áudio: ${error}`);
    }
  }

  static async transcription(
    audioFile: File,
    messageUuid: string
  ): Promise<TranscriptionSuccessResponse> {
    const url = `/ia/messages/transcription`;

    const formData = new FormData();
    formData.append('file', audioFile);
    formData.append('messageUuid', messageUuid);

    const response =
      await poliApiGatewayRequest.post<TranscriptionSuccessResponse>(
        url,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
    return response.data;
  }
}
